import React from "react";
import classnames from "classnames";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
//icons
import ActionPrint from "@material-ui/icons/Print";
// jazasoft
import { PageHeader, PageFooter, BackButton, showNotification } from "jazasoft";
// local
import OrderDetails from "../../OrderDetails";
import MicroController from "./MicroController";
//helpers
import { printBundleSheet } from "../../feedback/feedbackHelper";
import { MicroReportId } from "../../../constants";
import { OState } from "../../../utils/types";

const styles = theme => ({
  root: {},
  container: {
    margin: "1.5em",
    padding: 0
  },
  marginVertical: {
    margin: "1.5em 0"
  },
  displayCenter: {
    display: "flex",
    justifyContent: "center",
    margin: "1.5em"
  }
});

class BundleReportView extends React.Component {
  state = {
    busy: false,
    deviationTypes: undefined
  };

  onPrint = orderFlow => () => {
    if (orderFlow.stateValue > OState.REMNANT_CUTPLAN_COMPLETED.stateValue) {
      this.setState({ busy: true });
      const { order } = this.props;
      this.props.fetchBundles(orderFlow, bundleSheet => {
        printBundleSheet({ order, orderFlow, bundleSheet, layNo: -1 });
        this.setState({ busy: false });
      });
    } else {
      this.props.dispatch(showNotification("Planning not done yet."));
    }
  };

  render() {
    const { classes, order, basePath, i18nKey, resource, orderFlowMap } = this.props;

    const orderFlowList = orderFlowMap ? Object.keys(orderFlowMap).map(key => orderFlowMap[key]) : [];

    return (
      <div className={classnames(classes.root)}>
        <PageHeader title="Bundle Report" />

        {order && Object.keys(order).length > 0 && (
          <div id="container" className={classes.container}>
            {/*Order Details */}
            <OrderDetails
              id="order-details"
              className={classes.border}
              record={order}
              basePath={basePath}
              resource={resource}
              i18nKey={i18nKey}
            />
            {orderFlowList.length > 0 && (
              <Paper className={classes.marginVertical} square>
                <List>
                  {orderFlowList.map((oc, idx) => (
                    <ListItem key={idx}>
                      <ListItemText>{`${oc.product?.name} ${oc.styles}, ${oc.colors}, ${oc.part}, Lot${oc.lot} `}</ListItemText>
                      <ListItemSecondaryAction>
                        <Button
                          edge="end"
                          aria-label="Print"
                          color="primary"
                          onClick={!this.state.busy ? this.onPrint(oc) : null}>
                          <ActionPrint style={{ marginRight: 4 }} />
                          Print
                        </Button>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </Paper>
            )}
            {orderFlowList.length === 0 && (
              <div className={classes.displayCenter}>
                <Typography color="secondary" variant="h6">
                  Report not available
                </Typography>
              </div>
            )}

            <PageFooter>
              <BackButton variant="contained" color="default" />
            </PageFooter>
          </div>
        )}
      </div>
    );
  }
}

const StyledBundleReport = withStyles(styles)(BundleReportView);

const BundleReport = props => (
  <MicroController microReportId={MicroReportId.BUNDLE_TICKET} {...props}>
    {controllerProps => <StyledBundleReport {...props} {...controllerProps} />}
  </MicroController>
);

export default BundleReport;
